import getAvailability from "@/vue/planning/logic/getAvailability";
import { packConfigForCheckingAvailability } from "@/config/packConfigForCheckingAvailability";
import { AvailabilitiesResponse } from "@/types/responses";

const getFirstAvailableResponse = async (
	storeObj: any
): Promise<AvailabilitiesResponse> => {
	for (const packCode of packConfigForCheckingAvailability) {
		const avail_resp: AvailabilitiesResponse | null = await getAvailability(
			packCode,
			storeObj.state.startDate,
			storeObj.state.endDate,
			storeObj
		);
		if (
			avail_resp &&
			avail_resp["endDates"] &&
			avail_resp["endDates"]["startDate"]
		) {
			storeObj.state.currentPackCode = packCode;
			storeObj.state.reviewNumberPerLihe = avail_resp.reviewNumberPerLihe;
			storeObj.state.averageRatingPerLihe = avail_resp.averageRatingPerLihe;
			return avail_resp;
		}
	}
	return {};
};

export default getFirstAvailableResponse;
